import { useEffect } from 'react';

export const useKeyDown = (key: string, handleKeyDown: (event: any) => void) => {
  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === key) {
        handleKeyDown(event);
      }
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [key, handleKeyDown]);
};
